import React, { useEffect } from 'react'
import {Spin, Empty} from 'antd';
import { useSelector } from 'react-redux';
import { fetchKeyTagData } from '../../API/api';
import { bindActionCreators } from 'redux';
import { Actions } from '../../Action';
import { useDispatch } from 'react-redux';
import PaginationComp from '../../NewComponent/Pagination/Pagination';
import { useNavigate } from 'react-router-dom';
import { Home_PAGE_URL } from '../../Router/routerUrl';
import { replacepercentageSymbol } from '../../utils';

export default function VizData() {
    const tagState = useSelector(state=>state.keyTag);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {getKeyTagsData, KeyTagsDataPageNoUpdate, KeyTagsDataIsLoading,getkeyTagPayload} = bindActionCreators(Actions, dispatch);
    const fetchData = ()=>{
        KeyTagsDataIsLoading(true)
        fetchKeyTagData(tagState.pageNo, tagState.tagSelectedPayload.tag,tagState.tagSelectedPayload.key, tagState.searchQuery ).then(res=>{
            if(res===undefined){
                return
            }
            if(res.data.data===undefined){
                getKeyTagsData({data: [], count: 0});
                return;
            }
            getKeyTagsData({data:res.data.data.tagsQaData, count:res.data.data.totalCount});
        })
    }
    const queryStyles={
        color:'#5C6676',
        fontSize:'16px',
        fontWeight:'300',
        lineHeight:'24px',
        border: '1px solid #E0E2E6',
        padding:'8px 16px 8px 16px',
        borderRadius:'8px',
        marginBottom:'5px',
        cursor:'pointer'
    }
    const onClickText=(text)=>{
        getkeyTagPayload(null)
        navigate(`${Home_PAGE_URL}search/${encodeURIComponent(replacepercentageSymbol(text))}/false`)
    }
    useEffect(()=>{
        fetchData();
    }, [tagState.pageNo, tagState.searchQuery])
  return (
    <div className='mt-4'>
            {tagState.isLoading && <Spin size='large' spinning={true}>
                <div style={{height:'100px'}}></div>
            </Spin>}
            {!tagState.isLoading && tagState.data2.length===0 && <Empty/>}
            {!tagState.isLoading && tagState.data2.length !==0 && tagState.data2.map((query,ind)=>{
                return(
                    <div key={ind} style={queryStyles} onClick={()=>onClickText(query.text)}>
                        <span>{query.text}</span>
                    </div>
                )
            })}
{!tagState.isLoading && tagState.totalCount !==0&& <div style={{ display: "flex", justifyContent:'end' }}>
    <PaginationComp page={tagState.pageNo+1} total={tagState.totalCount} onChangeFunc={(e)=>KeyTagsDataPageNoUpdate(e-1)} /> 
</div>}
    </div>
  )
}
